import { ThemeOptions } from '@material-ui/core';

export const defaultTheme: ThemeOptions = {
    palette: {
        background: {
            default: '#F5F5F5',
            paper: '#FFF',
        },
        primary: {
            main: '#D3A02A',
            contrastText: '#FFF',
        },
    },
    typography: {},
    overrides: {
        MuiButton: {
            root: {
                borderRadius: 45,
            },
        },
    },
};
